module.exports = __webpack_public_path__ + "static/media/logoNegativo.4942feb9.png";